/**
 * Determine whether an object is a 'not found' atom
 * @param {*} value The object to test
 * @return {boolean} Whether the object is a 'not found' atom
 */
function isNotFound(value) {
  return Boolean(value) && (value.$type === 'notFound');
}

module.exports = isNotFound;
